// extracted by mini-css-extract-plugin
export var dropdownContainer = "_os-0";
export var leftAlign = "_os-4";
export var listItem = "_os-2";
export var listItemWrapper = "_os-1";
export var operationText = "_os-3";